import { render, staticRenderFns } from "./TermsOfServicePage.vue?vue&type=template&id=ea11752a&scoped=true"
import script from "./TermsOfServicePage.vue?vue&type=script&lang=js"
export * from "./TermsOfServicePage.vue?vue&type=script&lang=js"
import style0 from "./TermsOfServicePage.vue?vue&type=style&index=0&id=ea11752a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea11752a",
  null
  
)

export default component.exports